<div class="delete-dialog-container">
    <h2 class="dialog-heading">
        {{ data.title ? data.title : (data.content ? data.content + ' ' + data.id : 'Delete Confirmation') }}
    </h2>
    <div class="dialog-separator"></div>
    <div class="dialog-body-section">
        <p class="dialog-message-text">
            {{ data.message ? data.message : 'Are you sure you want to delete?' }}
        </p>
    </div>
    <div class="dialog-actions-section">
        <button mat-dialog-close [mat-dialog-close]="data.id" cdkFocusInitial type="button" class="btn-delete-confirm">{{ deleteText }}</button>
        <button mat-dialog-close type="button" class="btn-cancel-confirm">{{ cancelText }}</button>
    </div>
</div>
